import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { SLINKY } from 'HubStyleTokens/colors';
import { TABLE_HEADER_FONT_SIZE } from 'HubStyleTokens/sizes';
import { WEB_FONT_MEDIUM_WEIGHT } from 'HubStyleTokens/misc';
import UIBreakString from 'UIComponents/text/UIBreakString';
import Grid from '../Grid';
import GridItem from '../GridItem';
const sharedCellStyles = css(["&&{border-width:0;height:auto;text-align:left;}"]);
const StyledHeader = styled.div.withConfig({
  displayName: "Requirement__StyledHeader",
  componentId: "sc-10496z9-0"
})(["", " font-weight:", ";font-size:", ";color:", ";"], sharedCellStyles, WEB_FONT_MEDIUM_WEIGHT, TABLE_HEADER_FONT_SIZE, SLINKY);
const StyledValue = styled.div.withConfig({
  displayName: "Requirement__StyledValue",
  componentId: "sc-10496z9-1"
})(["", " &&{line-height:26px;}"], sharedCellStyles);
const StyledGrid = styled(Grid).withConfig({
  displayName: "Requirement__StyledGrid",
  componentId: "sc-10496z9-2"
})(["width:100%;"]);

const Requirement = ({
  header,
  value
}) => {
  const headerColumns = useMemo(() => ({
    mobile: 12,
    base: 12,
    desktop: 4
  }), []);
  const valueColumns = useMemo(() => ({
    mobile: 12,
    base: 12,
    desktop: 8
  }), []);
  return /*#__PURE__*/_jsxs(StyledGrid, {
    children: [/*#__PURE__*/_jsx(GridItem, {
      columns: headerColumns,
      children: /*#__PURE__*/_jsx(StyledHeader, {
        children: header
      })
    }), /*#__PURE__*/_jsx(GridItem, {
      columns: valueColumns,
      children: /*#__PURE__*/_jsx(StyledValue, {
        children: /*#__PURE__*/_jsx(UIBreakString, {
          children: value
        })
      })
    })]
  });
};

export default Requirement;